import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "user-cancelled" }
const _hoisted_2 = { class: "text" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([$props.mode])
    }, [
      _createVNode(_component_Icon, {
        class: "icon",
        height: "2rem",
        width: "2rem",
        icon: "alert-circle",
        stroke: $options.c_icon
      }, null, 8 /* PROPS */, ["stroke"]),
      _createElementVNode("div", _hoisted_2, _toDisplayString($props.text), 1 /* TEXT */)
    ], 2 /* CLASS */)
  ]))
}